<template>
  <div>
    <ContentWrap title="直播标签">
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button type="primary" plain @click="handleAdd" v-hasPermi="['live:tag:update']">
            <Icon icon="ep:plus" />新增
          </el-button>
        </el-col>
      </el-row>
    </ContentWrap>

    <ContentWrap>
      <el-table v-loading="loading" :data="list" border>
        <el-table-column label="编号" prop="id" width="80" />
        <el-table-column label="标签名称" prop="name" min-width="140" />
        <el-table-column label="排序" prop="sort" width="80" />
        <el-table-column label="推荐" prop="recommended" width="90">
          <template #default="scope">
            <el-tag v-if="scope.row.recommended" type="danger">推荐</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" width="90">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">{{
              scope.row.status === 1 ? '启用' : '停用'
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          min-width="180"
          :formatter="dateFormatter"
        />
        <el-table-column label="操作" width="180" fixed="right">
          <template #default="scope">
            <el-button
              link
              type="primary"
              @click="handleEdit(scope.row)"
              v-hasPermi="['live:tag:update']"
              >修改</el-button
            >
            <el-button
              link
              type="danger"
              @click="handleDelete(scope.row)"
              v-hasPermi="['live:tag:delete']"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        v-model:page="queryParams.pageNo"
        v-model:limit="queryParams.pageSize"
        @pagination="getList"
      />
    </ContentWrap>

    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="500px" append-to-body>
      <el-form
        ref="formRef"
        :model="form"
        :rules="withLiveInputLimits(rules, liveInputLimits)"
        label-width="100px"
      >
        <el-form-item label="标签名称" prop="name">
          <el-input
            show-word-limit
            :maxlength="64"
            v-model="form.name"
            placeholder="请输入标签名称"
          />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            :precision="0"
            v-model="form.sort"
            :min="0"
            :max="9999"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="推荐" prop="recommended">
          <el-switch v-model="form.recommended" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { withLiveInputLimits } from '@/utils/liveInputLimits'
const liveInputLimits = { name: 64 }

import { dateFormatter } from '@/utils/formatTime'
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { page, save, deleteTag } from '@/api/live/tag'

const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const dialogVisible = ref(false)
const dialogTitle = ref('')
const formRef = ref<any>(null)

const queryParams = reactive({ pageNo: 1, pageSize: 10 })

const form = reactive({
  id: undefined as number | undefined,
  name: '',
  sort: 0,
  recommended: false,
  status: 1
})

const rules = {
  name: [{ required: true, message: '标签名称不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '状态不能为空', trigger: 'change' }]
}

const getList = async () => {
  loading.value = true
  try {
    const data: any = await page(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const resetForm = () => {
  form.id = undefined
  form.name = ''
  form.sort = 0
  form.recommended = false
  form.status = 1
}

const handleAdd = () => {
  resetForm()
  dialogTitle.value = '新增直播标签'
  dialogVisible.value = true
}

const handleEdit = (row: any) => {
  resetForm()
  Object.assign(form, row)
  dialogTitle.value = '修改直播标签'
  dialogVisible.value = true
}

const submitForm = async () => {
  await formRef.value?.validate()
  await save(form)
  ElMessage.success(form.id ? '修改成功' : '新增成功')
  dialogVisible.value = false
  getList()
}

const handleDelete = (row: any) => {
  ElMessageBox.confirm('确认删除该标签吗？', '提示', { type: 'warning' }).then(async () => {
    await deleteTag(row.id)
    ElMessage.success('删除成功')
    getList()
  })
}

onMounted(() => {
  getList()
})
</script>
